module.exports = __webpack_public_path__ + "static/media/laddu_page02.e644222b.png";